import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

import { Button } from "@/components/ui/button";
import { usePageSeo } from "@/hooks/usePageSeo";
import { STATIC_PAGE_CONTENT } from "@/utils/newsroomStaticContent";

export const StaticNewsroomPage = ({ pageKey }) => {
  const page = STATIC_PAGE_CONTENT[pageKey];

  usePageSeo({
    canonicalPath: page.route,
    description: page.description,
    title: `${page.title} | Content Watch HQ`,
  });

  return (
    <main className="page-shell mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-14 lg:px-8 lg:py-16" data-testid={`static-page-${pageKey}`}>
      <section className="border border-[#D9DCE1] bg-white p-8 shadow-[0_20px_60px_rgba(15,23,42,0.04)] sm:p-10" data-testid={`static-page-hero-${pageKey}`}>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#D21404]" data-testid={`static-page-overline-${pageKey}`}>{page.overline}</p>
        <h1 className="mt-4 font-[Bebas_Neue] text-5xl uppercase tracking-[0.04em] text-[#0A0A0A] sm:text-6xl" data-testid={`static-page-title-${pageKey}`}>{page.title}</h1>
        <p className="mt-4 max-w-3xl text-lg leading-8 text-slate-700" data-testid={`static-page-description-${pageKey}`}>{page.description}</p>
        <p className="mt-6 border-l-4 border-[#1338BE] pl-4 text-sm font-semibold uppercase tracking-[0.2em] text-[#1338BE]" data-testid={`static-page-intro-${pageKey}`}>{page.intro}</p>
      </section>

      <section className="mt-10 grid gap-6 md:grid-cols-2 xl:grid-cols-3" data-testid={`static-page-sections-${pageKey}`}>
        {page.sections.map((section) => (
          <article key={section.heading} className="border border-[#D9DCE1] bg-[#F8F9FA] p-6 sm:p-7" data-testid={`static-page-section-card-${pageKey}-${section.heading.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <h2 className="font-[Montserrat] text-xl font-bold uppercase tracking-[0.08em] text-[#0A0A0A]">{section.heading}</h2>
            <p className="mt-4 text-sm leading-7 text-slate-700">{section.body}</p>
          </article>
        ))}
      </section>

      <div className="mt-10 flex flex-wrap gap-3" data-testid={`static-page-actions-${pageKey}`}>
        <Button asChild className="rounded-none bg-[#1338BE] px-5 py-5 text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#102F9B]" data-testid={`static-page-contact-button-${pageKey}`}>
          <Link to="/contact">
            Contact the newsroom
            <ArrowRight size={16} weight="bold" />
          </Link>
        </Button>
        <Button asChild className="rounded-none border border-[#0A0A0A] bg-transparent px-5 py-5 text-xs font-bold uppercase tracking-[0.2em] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white" data-testid={`static-page-home-button-${pageKey}`} variant="ghost">
          <Link to="/">Back Home</Link>
        </Button>
      </div>
    </main>
  );
};